import React, {useState} from "react";

const SNACKBAR_TIMEOUT_ERROR = 10000;
const SNACKBAR_TIMEOUT_SUCCESS = 2000;

export const enum SnackbarStatus {
    success,
    neutral,
    error
}

export const SnackbarContext = React.createContext({
    msg: "",
    status: SnackbarStatus.neutral,
    duration: 4000,
    isDisplayed: false,
    displayMsg: (_msg: string, _status: SnackbarStatus, _duration: number = SNACKBAR_TIMEOUT_SUCCESS) => {
    },
    onClose: () => {
    },
});

let timer: NodeJS.Timeout | undefined = undefined;
export const SnackBarContextProvider = (props) => {
    const [msg, setMsg] = useState("");
    const [status, setStatus] = useState(SnackbarStatus.neutral);
    const [duration, setDuration] = useState(4000);
    const [isDisplayed, setIsDisplayed] = useState(false);

    const displayHandler = (msg, status: SnackbarStatus, duration: number = SNACKBAR_TIMEOUT_SUCCESS) => {
        clearTimeout(timer);
        setMsg(msg);
        setStatus(status);
        setDuration(status.valueOf() === SnackbarStatus.error.valueOf() ? SNACKBAR_TIMEOUT_ERROR : duration)
        setIsDisplayed(true);
        timer = setTimeout(() => {
            closeHandler();
        }, status.valueOf() === SnackbarStatus.error.valueOf() ? SNACKBAR_TIMEOUT_ERROR : duration);
    };

    const closeHandler = () => {
        clearTimeout(timer);
        setIsDisplayed(false);
    };

    return (
        <SnackbarContext.Provider value={{msg, status, duration, isDisplayed, displayMsg: displayHandler, onClose: closeHandler}}>
            {props.children}
        </SnackbarContext.Provider>
    );
};

export default SnackbarContext;
